import { initializePreferences } from './lib/preferences-storage';
import './index.css';

void initializePreferences()
  .then(() => import('./app'))
  .catch(() => {
    console.error('[storage] Unable to load saved preferences.');
    const root = document.getElementById('root');
    if (root) {
      root.className = 'p-4 text-sm text-content';
      root.textContent = "Couldn't load saved data. Please reopen the app.";
    }
  });
